import * as React from "react";
import { connect } from 'react-redux';
import { fetchOrden, fetchDatosComprador } from '../../../actions/ordenesActions';
import { limpiarFiltros } from '../../../actions/generalActios';
import DatosComprador from "../DatosComprador";
import MedioDePago from "../MedioDePago";
import Productos from "../Productos";
import Estados from "../Estados/EstadosOrden";
import Entrega from "../Entrega";
import Tab from '../../General/Tab'
import Spinner from 'react-bootstrap/Spinner';

class OrdenEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0,
            tabs: [
                { name: "Datos comprador", content: <DatosComprador idOrden={this.props.match.params.id} ordenVerde={true} newOrden={false}/>},
                { name: "Productos", content: <Productos newOrden={false} ordenVerde={true} />},
                { name: "Entrega", content: <Entrega newOrden={false} ordenVerde={true} />},
                { name: "Medio de pago", content: <MedioDePago newOrden={false} ordenVerde={true} />},
                { name: "Estados", content: <Estados history={this.props.history} newOrden={false} ordenVerde={true} />}
            ]
        }
    }

    componentDidMount() {
        this.props.fetchOrden(this.props.match.params.id);
        this.props.fetchDatosComprador(this.props.match.params.id);
    }

    onChangeActiveTab = (index) => {
        this.setState({ activeTab: index });
    }

    return = () => {

        if (this.props.emptyFiltro.ordenes == false) {
            this.props.limpiarFiltros({ 
                publicaciones: true, 
                ordenes: false, 
                sellers: true, 
                showFiltro: false, 
                showFiltroOrdenes: true
            })
        }

        const pathReturn = this.props.location.state;
        this.props.history.push(`${pathReturn}`);
    }


    render() {
        
        let numeroOrden = this.props.match.params.id;
        let orden = JSON.stringify(this.props.orden);
        let idVendedorBoca = null;
        let imgLogo = null;

        const switchLogo = (plataformaCodigo) => {

            switch (plataformaCodigo) {
                case 0:
                    return '/img/icono-megatone.png'
                case 1:
                    return '/img/icono-mega-Market.png'
                case 2:
                    return '/img/icono-megatone-express.png'
                default:
                    return ""
            }
        }

        if (orden != undefined) {
            if (orden != "{}") {
                idVendedorBoca = this.props.orden.idVendedorBoca;
                imgLogo = 
                <img 
                    alt="icon_mega" 
                    hidden={this.props.tipoUsuario !== 2} 
                    src={
                        this.props.orden.seller.urlLogo != undefined ? 
                        (this.props.orden.seller.urlLogo != "" ? this.props.orden.seller.urlLogo : 
                        process.env.PUBLIC_URL + switchLogo(this.props.orden.plataforma.codigo)) : 
                        process.env.PUBLIC_URL + switchLogo(this.props.orden.plataforma.codigo)
                    } 
                    style={{ position: "absolute", top: "10px", right: "20px", width: "50px" }} 
                />
            }
        }
        

        return (
            <div className="col-sm-12">

                <div hidden={!this.props.loadingOrdenes}>
                    <div className="d-flex justify-content-center">
                        <Spinner animation="border" variant="secondary" size="lg-centrado" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                </div>

                <div className="card" hidden={this.props.loadingOrdenes}>

                    {imgLogo}

                    <label 
                        hidden={this.props.tipoUsuario !== 2} 
                        style={{ fontWeight: "bold", position: "absolute", top: "70px", right: "23px" }}
                    >
                        {idVendedorBoca == 0 ? "" : idVendedorBoca}
                    </label>

                    <div className="card-body p-b-0">
                        <h4 className="card-title">Orden - {numeroOrden}</h4>
                        <h5 className="card-subtitle"></h5>
                        <ul className="nav nav-tabs customtab" role="tablist">
                        {
                            this.state.tabs.map((tab, index) => {
                                return <div key={index} onClick={() => { this.onChangeActiveTab(index) }}>
                                    <Tab 
                                        name={tab.name} 
                                        icon="ti-home"
                                        isActive={(index == this.state.activeTab) ? true : false} 
                                    />
                                </div>
                            })
                        }
                        </ul>
                        <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit}>
                            <div className="tab-content">
                                {this.state.tabs[this.state.activeTab].content}
                                <div className="row">
                                    <button 
                                        onClick={this.return} 
                                        className="btn btn-sm btn-light waves-effect waves-light mb-md-5"
                                    >
                                        Volver
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    loadingOrdenes: state.ordenes.loadingOrdenes,
    orden: state.ordenes.orden,
    emptyFiltro: state.general.limpiar
});

export default connect(mapStateToProps, { 
    fetchOrden, 
    fetchDatosComprador, 
    limpiarFiltros 
}) (OrdenEdit);